import React from 'react'
import HowItWorks from 'src/components/Footer/HowItWorks'

import KlarnaImg from 'src/assets/images/klarna-payments.png'
import KlarnaPaymentsInfo from 'src/components/Footer/KlarnaPaymentsInfo'
import HomeHeader from 'src/components/HomeHeader'
import ProductsPage from 'src/pages/ProductsPage'

export const HomePage = () => {
  return (
    <>
      <HomeHeader />
      <ProductsPage />
      <HowItWorks />
      <KlarnaPaymentsInfo />
    </>
  )
}

export default HomePage
